import React from "react";
import NoData from "@/components/NoData";

const FirstGoalTime = ({ data, isSameChecked }) => {
  const labels = [
    "1-10'",
    "11-20'",
    "21-30'",
    "31-40'",
    "41-50'",
    "51-60'",
    "61-70'",
    "71-80'",
    "81-90'+",
  ];

  const { home, away } = isSameChecked ? data?.normal : data?.similarity;

  const homeArray = home.split(",").map((item) => (item == "-" ? 0 : item));
  const awayArray = away.split(",").map((item) => (item == "-" ? 0 : item));

  const renderFirstGoalTime = () => {
    if (home === "-" || away === "-") {
      return <NoData />;
    }

    return labels.map((label, index) => (
      <div className={"flex flex-col gap-2 "}>
        <div className={"flex flex-row gap-2 [&>*]:flex-1 "}>
          <div
            className={
              "w-[30px] h-[88px] flex flex-col justify-end bg-[#ebeff5] rounded-tl rounded-tr text-button-blue-bet dark:bg-dark-slate"
            }
          >
            <div>{homeArray[index] || ""}</div>
            <div
              className={"bg-button-blue-bet"}
              style={{ height: `${homeArray[index] * 10}%` }}
            ></div>
          </div>
          <div
            className={
              "w-[30px] h-[88px] flex flex-col justify-end bg-[#f6f5ef] rounded-tl rounded-tr text-golden-yellow dark:bg-dark-slate"
            }
          >
            <div>{awayArray[index] || ""}</div>
            <div
              className={"bg-golden-yellow"}
              style={{ height: `${awayArray[index] * 10}%` }}
            ></div>
          </div>
        </div>
        <div className={"w-full rounded font-semi-bold dark:text-white text-center"}>
          {label}
        </div>
      </div>
    ));
  };

  return (
    <div
      className={
        "w-full text-xs  flex flex-row gap-3 @md:gap-4 [&>*]:flex-1 [&>*]:text-center [&>*:first-child]:pl-[0] [&>*:last-child]:pr-[0] divide-league-dark-detail text-blur-gray overflow-auto p-2"
      }
    >
      {renderFirstGoalTime()}
    </div>
  );
};

export default FirstGoalTime;
